exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb {\n    letter-spacing: 2px;\n    font-size: 1.5rem;\n    font-weight: 300;\n    line-height: 1.1;\n    background-color: transparent;\n}\n\n.breadcrumb a {\n    color: #75798c;\n}\n\n.breadcrumb span {\n    color: #75798c;\n    font-weight: bold;\n}\n\n.breadcrumb span:before {\n    font-weight: normal;\n}\n\n.modal-body label {\n    margin-right: 20px;\n}\n\n.list-title {\n    margin-top: 30px;\n    color: #75798c;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/folder/folders-view/folders-view.component.css
// module id = 745
// module chunks = 0